module.exports = __webpack_public_path__ + "static/media/Assets-10-Si-Mayaa-01.f640e6da.png";